type Balance = { gt(value: number): boolean };

export const hasBothTestAssets = (fuel: Balance, stFuel: Balance) => fuel.gt(0) && stFuel.gt(0);
